import React, { useState } from "react";

import CustomButton from "../../CustomButton/CustomButton";
import {
  SelectedRowsButtonsContainer,
  WhatsAppContainer,
} from "./SelectedRowsButtonsContainer";
import DialogComponent from "../../DialogComponent/DialogComponent";
import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { axiosFunction } from "../../../commonFunctions/axiosFunction";
import { v2ReactURL } from "../../../../utils/constant";
import { DeleteContactFunc } from "../../../commonFunctions/DeleteContactFunc";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MandatoryField from "../../../../utils/MandatoryField";
import { toastMessage } from "../../../commonFunctions";
import {DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import {OptionMenu} from "../../index";

interface SelectedRowsButtonsProps {
  selectedRows: number[];
  resetLoyaltyPoints?: (all: boolean) => void;
  setSelectedRows: (rows: number[]) => void;
  setDeleteSuceessRes?: (value: boolean) => void;
  dynamicMenuAction?: any;
  fetchData: () => Promise<void>; 
  refreshAnalytics?: boolean,
  setRefreshAnalytics?: React.Dispatch<React.SetStateAction<boolean>>,
}

const SelectedRowsButtons = ({ selectedRows, fetchData,dynamicMenuAction,resetLoyaltyPoints,refreshAnalytics,setRefreshAnalytics }: SelectedRowsButtonsProps) => {
 
  const [sendWhatsappModal, setSendWhatsappModal] = useState<boolean>(false);
  const [fileTypeOption, setFileTypeOption] = useState<string>("textMessage");
  const [messageState, setMessageState] = useState<string>("");
  const [file, setFile] = useState<File | null>(null);
  const sessionList = useSelector((state: any) => state.sessionData.sessionScope);
  // const sessionBranchId = sessionList?.branchId;
  // const dynamicMenuAction = useSelector((state: any) => state.dynamicMenuAction);

  const navigate = useNavigate();

  const contactType = useSelector((state:any) => state.contactType);

  const handleFileTypeChange = (e: SelectChangeEvent<string>) => {
    setFileTypeOption(e.target.value);
  };

  const fileTypeOptions = [
    {
      title: "Text Message",
      value: "textMessage",
    },
    {
      title: "Image",
      value: "image",
    },
    {
      title: "Audio",
      value: "audio",
    },
    {
      title: "Video",
      value: "video",
    },
    {
      title: "File",
      value: "file",
    },
  ];

  

  const handleDeleteBtn = async () => {
    DeleteContactFunc(selectedRows, navigate, contactType ,refreshAnalytics,setRefreshAnalytics,false, () => fetchData());
    
  };

  const whatsappDialogContent = () => {
    const acceptFileType = fileTypeOption + "/*";

    const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFile = e.target.files?.[0];

      if (selectedFile && selectedFile.size <= 8 * 1024 * 1024) {
        setFile(selectedFile);
      } else {
        toastMessage("File size should be less than 8MB");
        e.target.value = "";
      }
    };

    return (
      <WhatsAppContainer>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ fontWeight: "bold" }}>File Type</label>
          <FormControl sx={{ m: 0, minWidth: 100 }}>
            <Select
              value={fileTypeOption}
              onChange={handleFileTypeChange}
              displayEmpty
              inputProps={{ "aria-label": "file type" }}
            >
              {fileTypeOptions.map((fileType) => (
                <MenuItem value={fileType.value} key={fileType.value}>
                  {fileType.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <div
          style={{ display: "flex", flexDirection: "column", marginTop: "5px" }}
        >
          <label style={{ fontWeight: "bold" }}>
            Message
            <MandatoryField />
          </label>
          <div style={{ position: "relative" }}>
            <textarea
              value={messageState}
              onChange={(e) => setMessageState(e.target.value)}
              className="customTextArea"
            />
          </div>
        </div>

        {fileTypeOption !== "textMessage" && (
          <div>
            <label style={{ fontWeight: "bold" }}>File Upload</label>
            <input
              onChange={(e) => handleFileUpload(e)}
              type="file"
              accept={acceptFileType}
            />
          </div>
        )}
      </WhatsAppContainer>
    );
  };

  const handleSendWhatsapp = async () => {
    if (messageState === "") {
      toastMessage("Please Write Message");
    } else {
      const formData = new FormData();

      selectedRows.forEach((id) => {
        formData.append("contactid", id.toString());
      });
      
      formData.append("pageType", "0");
      formData.append("fileType", fileTypeOption);
      formData.append("message", messageState);
      file &&  formData.append("file", file);

      // Make the API call
      const response = await axiosFunction(
        `${v2ReactURL}/whatsapp/customers/sendsms`,
        "POST",
        formData,
        true
      );

      if (response.status === 200) {
        setMessageState("");
        setFile(null);
        setFileTypeOption("textMessage");
        setSendWhatsappModal(!sendWhatsappModal);
        toastMessage(response?.data, "info");
      }
    }
  };

  const handleCloseWhatsappModal = () => {
    setFileTypeOption("textMessage");
    setSendWhatsappModal(!sendWhatsappModal);
    setMessageState("");
    setFile(null);
  };

  // console.log("LOAY ", dynamicMenuAction);
  

  return (
    <SelectedRowsButtonsContainer>
      {/* {contactType !== "transport" && (
        <CustomButton
          open={sendWhatsappModal}
          onClick={handleSendWhatsappBtn}
          className="whatsapp-btn"
          btnName={"Send WhatsApp"}
        />
      )} */}
      <CustomButton
        open={true}
        onClick={handleDeleteBtn}
        className="delete-btn"
        btnName={"Delete"}
      />
      &ensp;
      {Boolean(dynamicMenuAction?.Edit) && contactType === "customers" && (sessionList.companyId == sessionList.branchId) && Boolean(dynamicMenuAction?.loyalty) &&
          <UncontrolledDropdown>
            <DropdownToggle
                tag="a"
                onClick={(_) => {}}
            >
              <CustomButton
                  open={true}
                  onClick={() => {
                  }}
                  className="delete-btn h-100"
                  btnName={"Reset Loyalty Points"}
              />
            </DropdownToggle>

            <DropdownMenu style={{minWidth: "8rem"}}>
              <OptionMenu menuItems={
                <>
                  <MenuItem onClick={() => resetLoyaltyPoints && resetLoyaltyPoints(true)}>
                    All
                  </MenuItem>
                  <MenuItem onClick={() => resetLoyaltyPoints && resetLoyaltyPoints(false)}>
                    Selected
                  </MenuItem>
                </>

              }/>
            </DropdownMenu>
          </UncontrolledDropdown>
      }
      <DialogComponent
        handleClose={handleCloseWhatsappModal}
        dialogTitle={"Send WhatsApp"}
        openDialog={sendWhatsappModal}
        dialogContent={whatsappDialogContent()}
        handleSubmitBtn={() => handleSendWhatsapp()}
        disabledSubmitBtn={false}
        submitBtnStyle={""}
        submitBtnName="Send WhatsApp"
      />
    </SelectedRowsButtonsContainer>
  );
};

export default SelectedRowsButtons;
